import { Alert, Button, Flex, Image, useTheme } from "@aws-amplify/ui-react";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { LatLng } from 'leaflet';

import './LocationControls.css';
import ClientDeviceUtils from "../../utils/client/ClientDeviceUtils";

interface LocationControlsParams {
    updateLocationActive: (isMyLocationActive: boolean) => undefined
    myLocation: LatLng | undefined
    isActive: boolean
    isPositionLoading: boolean
}

const LocationControls: React.FC<LocationControlsParams> = ({ updateLocationActive, myLocation, isActive, isPositionLoading }) => {

    const { t } = useTranslation();
    useTheme();

    const isMobile = useMemo(() => ClientDeviceUtils.isMobileDevice(), []);
    const [isAlertExpanded, setIsAlertExpanded] = useState<boolean>(!isMobile);

    const updateLocationStatus = (event: React.MouseEvent) => {
        event.stopPropagation();
        updateLocationActive(!isActive)
    }

    const buttonImgageUrl = (): string => {

        if (myLocation) {
            return isActive ? '/icons/location/location_set_icon.svg' : '/icons/location/location_unset_icon.svg'
        } else {
            return '/icons/location/location_unavailable_icon.svg'
        }
    }

    return (
        <>
            <Flex
                direction="row"
                className="location-controls-flex"
                gap="1rem"
            >
                {!isPositionLoading && (
                    <Button
                        variation="primary"
                        className={"location-controls-activate-btn " + (myLocation ? "enabled" : "disabled")}
                        onClick={updateLocationStatus}
                        disabled={myLocation ? false : true}
                    >
                        <Image
                            className="location-controls-activate-img"
                            alt=""
                            src={buttonImgageUrl()}
                        />
                    </Button>
                )}
                {!isPositionLoading && !myLocation && (
                    <Alert
                        className={"location-controls-alert" + (isMobile && !isAlertExpanded ? " collapsed" : "")}
                        variation="warning"
                        hasIcon={true}
                        isDismissible={isAlertExpanded}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (isMobile && !isAlertExpanded) {
                                setIsAlertExpanded(true);
                            }
                        }}
                    >
                        {isAlertExpanded ? t('location.position-lost') : ""}
                    </Alert>
                )}
            </Flex>
        </>
    )
}

export default LocationControls